import { FC, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { getTheme } from "Store/MultiDomain/MultiDomain.selector"
import { LANGUAGE_STORAGE_KEY, SUPPORTED_LANGUAGES } from "i18n"
import Select, { IOptionData } from "Components/UI/Select"
import { Content, Top } from "./styles"

const options: IOptionData[] = SUPPORTED_LANGUAGES.map((lang) => ({
  value: lang.value,
  label: lang.label,
  description: lang.label,
}))

const LanguageSettings: FC = () => {
  const { t, i18n } = useTranslation(['notification'])
  const theme = useSelector(getTheme)

  const readStored = (): string | undefined => {
    try {
      const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY)
      return stored ?? undefined
    } catch {
      return undefined
    }
  }

  const [selected, setSelected] = useState<string | undefined>(readStored)

  const handleChange = (value: string) => {
    setSelected(value)
    try {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, value)
    } catch {
      // localStorage may be unavailable; still apply the language for this session.
    }
    i18n.changeLanguage(value)
  }

  return (
    <>
      <Top>
        <span className="title">
          {t('notification:preferences.language.groupTitle')}
        </span>
      </Top>
      <Content>
        <div className="row">
          <span className="rowText">
            <span className="rowTitle">
              {t('notification:preferences.language.systemLanguage.title')}
            </span>
            <span className="rowDescription">
              {t('notification:preferences.language.systemLanguage.description')}
            </span>
          </span>
          <span className="rowChange">
            <Select
              options={options}
              value={selected}
              size="small"
              className="select"
              placeholder={t('notification:preferences.language.placeholder')}
              customBackgroundColor={theme.colors.secondary.secondary}
              righticon={6}
              onChange={(value) => handleChange(value as string)}
            />
          </span>
        </div>
      </Content>
    </>
  )
}

export default LanguageSettings
